import React from "react";
import { Container } from "reactstrap";
import RouteSideNav from "../../../components/RouteSideNav";

interface DashboardProps {
  children: React.ReactNode;
}

const Dashboard = (props: DashboardProps) => {
  const { children } = props;
  return (
    <Container
      fluid
      className="h-screen text-black bg-white w-full flex flex-col lg:flex-row  p-0 m-0 overflow-hidden"
    >
      <RouteSideNav />
      <div className="flex-1 overflow-y-auto">{children}</div>
    </Container>
  );
};

export default Dashboard;
